// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","594":"about"}[chunkId] || chunkId) + "." + {"53":"f99d36fb","594":"9739bd8a","703":"79276f07"}[chunkId] + ".js";
};